Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-transaction-box');

    if ($wrappers.length < 1) return;

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var $detailsWrapper = $('.x-transaction-details-expandable', $wrapper);

        $('[data-click="expanded-transaction"]', $wrapper).on('click', function (e) {
            var $expandBtn = $(this);

            if ($expandBtn.hasClass('expanded')) {
                $detailsWrapper.slideUp();
                $expandBtn.removeClass('expanded');
            } else {
                $detailsWrapper.get(0).init();
                $detailsWrapper.slideDown();
                $expandBtn.addClass('expanded');
            }
        });
    });

});
